<template>
  <v-layout v-if="show">
    <v-img :src="require(`@/assets/awrim/group/g1.jpeg`)" :height="notHeight">
      <v-carousel  
        :interval="2000"
        :cycle="true"
        :height="notHeight"
        :hide-delimiters="true"
        :hide-delimiter-background="true"
        
        :show-arrows="notIndicators">  
        <v-carousel-item
          v-for="(donation,i) in donations"
          :key="i"  > 
          <v-sheet color="transparent" class="pa-5" height="100%">
            <v-overlay :color="donation.color?donation.color.hex:''"
              v-if="true"
              absolute >
              <v-layout v-if="notText" justify-center="" align-center=""
                  fill-height=""  column="" class="ma-5" width="1000">
                  <v-col sm="12" md="12" cols="12" >
                    <v-layout width="100%" fill-height="" column="" justify-center="" align-center="" >
                      <div class="not-f9 font-weight-black b1--text not-shadow text-center"><div></div>{{donation.title}}</div>  
                      <v-layout row wrap>
                          <v-icon :color="donation.color?donation.color.hex:''" size="80">mdi-calendar</v-icon> 
                      </v-layout> 
                      <div class="not-f7 font-weight-bold white--text not-shadow text-center ">DATE:{{not.convertDate(donation.startDate)}} - {{not.convertDate(donation.endDate)}}</div>
                        <br>
                        <v-hover v-slot:default="{hover}">
                          <v-btn :to="'/events/'"   rounded="" :class="hover?'':'primary--text'" :color="hover?'primary':'b2'">VIEW EVENTS</v-btn>
                        </v-hover>
                    </v-layout> 
                  </v-col>
              </v-layout>
            </v-overlay>
          </v-sheet> 
        </v-carousel-item>  
      </v-carousel>
    </v-img>
  </v-layout>
</template>

<script>
import { timeout } from 'q';
export default {
  props:["not","notShow","notHeight","notText","notIndicators","notImage","notDonations"],
  data: () => ({
    show:false, 
     
  }),
  mounted() {
    this.show = this.notShow
  },
  computed: {
    image(){
      let notImages = this.notImages
      return notImages
    },
    donations(){
      let donations = this.notDonations
      return donations
    },
  },
  watch: {
    notShow(v){
      this.show =v
    },
    notHeight(v){
      this.show = false
      setTimeout(() => {
        this.show = this.notShow
      }, 100);

      
    }
  },
};
</script>
